// @flow

import { useCallback } from 'react';
import { useTenant } from '@tectonics/commons/tenant';
import { useEnrollment } from '../context';
import { confirmEnrollment } from '../services/enrollment-api';
import { buildAuthenticationPayload } from '../services/authentication-payload';
import type { CredentialResponse } from '../services/webauthn';

export function useEnrollmentAuthentication(): (credentialData: CredentialResponse) => Promise<void> {
  const tenant = useTenant();
  const { data, dispatch } = useEnrollment();

  return useCallback(async (credentialData: CredentialResponse) => {
    dispatch({ type: 'START_SUBMITTING_AUTH' });

    try {
      const payload = buildAuthenticationPayload({
        contract: data.contract,
        credentialData,
      });

      const response = await confirmEnrollment(payload, tenant.code);

      if (response.enrollment?.status === 'accepted') {
        dispatch({ type: 'ENROLLMENT_SUCCESS', intentUrl: data.intentUrl });
      } else {
        dispatch({ type: 'SET_AUTH_ERROR', errorMessage: 'Falha ao confirmar vinculação. Tente novamente.' });
      }
    } catch (err) {
      dispatch({ type: 'SET_AUTH_ERROR', errorMessage: err.message || 'Falha ao confirmar vinculação.' });
    }
  }, [data.contract, data.intentUrl, tenant.code, dispatch]);
}
